module.exports = __webpack_public_path__ + "static/media/henry160px.c0fec8d9.jpg";